export default __webpack_public_path__ + "static/media/IMG_0829.a521e429.JPG";